var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleReservationOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 6.7625L6.275 4H8.30625L6.6 6.4375H11.7188C13.1194 6.4375 14.4627 6.99392 15.4532 7.98434C16.4436 8.97477 17 10.3181 17 11.7188C17 13.1194 16.4436 14.4627 15.4532 15.4532C14.4627 16.4436 13.1194 17 11.7188 17H8.0625L8.875 15.375H11.7188C12.6884 15.375 13.6184 14.9898 14.3041 14.3041C14.9898 13.6184 15.375 12.6884 15.375 11.7188C15.375 10.7491 14.9898 9.81907 14.3041 9.13339C13.6184 8.44771 12.6884 8.0625 11.7188 8.0625H6.6L8.30625 10.5H6.275L4.325 7.7375L4 7.25L4.325 6.7625Z",
    fill: "#262F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleReservationOpen);
export default __webpack_public_path__ + "static/media/toggle-reservation-open.294fd5b71ddbcfd13fa65a3e3fd27b0b.svg";
export { ForwardRef as ReactComponent };